import { Theme, Typography } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { ReactComponent as GenericIcon } from '../../../assets/icons/generic-icon.svg';
import DateFormat from '../../../elements/Date/DateFormat';
import ExternalLinkButton from '../../../elements/ExternalLinkButton/ExternalLinkButton';
import InfoIcon from '../../../elements/InfoIcon/InfoIcon';
import OwnerCell from '../../../elements/TableCells/OwnerCell';
import { ArtifactInfo } from '../../types/artifacts-type';
import { getScmIconType } from '../../utils/artifacts-utils';
import InfoIconSection from './InfoIconSection';
import InfoItemsWrapper from './InfoItemsWrapper';
import Section from './Section';

const ArtifactCodeInfo: FC<ArtifactCodeInfoProps> = ({ artifact }) => {
  const { classes } = useStyles();
  const SCMIcon = artifact.codeDescription?.scm
    ? getScmIconType(artifact.codeDescription?.scm)
    : GenericIcon;

  const sourceControl = artifact.codeDescription?.scm;
  const PRDate = new Date(Number(artifact.codeDescription?.prDate));
  const PROwner = artifact.codeDescription?.prOwner;
  const PRReviewers = artifact.codeDescription?.prReviewers;
  const sourceBranch = artifact.codeDescription?.sourceBranch;
  const destinationBranch = artifact.codeDescription?.destinationBranch;
  const fileChanges = artifact.codeDescription?.fileChanged;
  const mergeLink = artifact.codeDescription?.mergeLink;
  const appName = artifact.appDescription?.appName;
  const hash = artifact.artifactInfo?.hash || '';

  return (
    <div className={classes.artifactCodeInfo}>
      <InfoItemsWrapper>
        {appName && (
          <div>
            <Typography variant='body2' color='text.secondary'>
              App Name
            </Typography>
            <div className={classes.sourceControlType}>
              {SCMIcon && <SCMIcon height='1rem' />}
              <Typography variant='body1' color='text.primary'>
                {appName}
                <ExternalLinkButton
                  size='small'
                  href={mergeLink}
                  target='_blank'
                />
              </Typography>
            </div>
          </div>
        )}
        <Section label='Source Control'>{sourceControl}</Section>
        <Section label='Date'>
          {PRDate && <DateFormat date={PRDate} color='text.primary' bigSize />}
        </Section>

        <InfoIconSection
          label='Owner'
          labelIcon='The developer name of committer'>
          {PROwner && <OwnerCell owners={[PROwner]} />}
        </InfoIconSection>

        <InfoIconSection
          label='Code Reviewers'
          labelIcon='The person who review the code'>
          {PRReviewers && <OwnerCell owners={PRReviewers} />}
        </InfoIconSection>

        {/* {PRApprovers && PRApprovers.length > 0 && (
          <div>
            <Typography variant='body2' color='text.secondary'>
              
              <InfoIcon title={} marginX={1} />
            </Typography>
            <OwnerCell owners={PRApprovers} />
          </div>
        )} */}
        {PRReviewers && PRReviewers.length > 0 && (
          <div>
            <Typography variant='body2' color='text.secondary'>
              Code Reviewers
              <InfoIcon title={'he person who reviewd the code'} marginX={1} />
            </Typography>
            <OwnerCell owners={PRReviewers} />
          </div>
        )}
        {sourceBranch && (
          <div>
            <Typography variant='body2' color='text.secondary'>
              Source Branch
              <InfoIcon
                title={'The repository branch from which the changes came'}
                marginX={1}
              />
            </Typography>
            <Typography variant='body1' color='text.primary'>
              {sourceBranch}
            </Typography>
          </div>
        )}
        {destinationBranch && (
          <div>
            <Typography variant='body2' color='text.secondary'>
              Destination Branch
              <InfoIcon
                title={'The repository branch which created the artifact'}
                marginX={1}
              />
            </Typography>
            <Typography variant='body1' color='text.primary'>
              {destinationBranch}
            </Typography>
          </div>
        )}
        {fileChanges && fileChanges.length > 0 && (
          <div>
            <Typography variant='body2' color='text.secondary'>
              Files Changed
            </Typography>
            <div>
              {fileChanges.map(change => (
                <Typography
                  variant='body1'
                  color='text.primary'
                  mb={0.5}
                  key={change.fileName}>
                  {change.change} in {change.fileName}
                </Typography>
              ))}
            </div>
          </div>
        )}
        {hash && <Section label='Hash'>{hash}</Section>}
      </InfoItemsWrapper>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  artifactCodeInfo: {
    paddingBlockEnd: theme.spacing(2),
  },
  sourceControlType: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
}));

export interface ArtifactCodeInfoProps {
  artifact: ArtifactInfo;
}

export default ArtifactCodeInfo;
